import { ReactNode } from 'react'
import styles from './styles.module.scss'
import { Button, Space, Table, Upload } from 'antd'
import { RcFile, UploadProps } from 'antd/lib/upload'
import { useSetupHook } from './hooks'
import {
  CheckOutlined,
  SyncOutlined,
  InfoCircleFilled,
} from '@ant-design/icons'
import _ from 'lodash'
import PreviewModal from '../previewModal'
export type ResultType = '上传中' | '成功' | '失败'
// export type ErrorType='exceedLimit'|'timeout'|'不支持此文件格式'
export const resultDict: { [key in ResultType]: any } = {
  上传中: {
    node: <span>上传中...</span>,
  },
  成功: { node: <span> 成功</span> },
  失败: { node: <span> 失败</span> },
}
export interface UploadFileItem
  extends Partial<Pick<RcFile, 'size' | 'name' | 'uid' | 'type'>> {
  uid: string
  name: string
  resultType: ResultType
  errorMessage?: string
  originFile: File
  osspath?: string
  url: string
}
export interface Props extends Omit<UploadProps, 'onChange'> {
  uploadButton?: ReactNode
  maxCount?: number
  onChange?: (newUploadFileList: UploadFileItem[]) => void
  value?: any
}
export default function BatchUpload(props: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { uploadButton, onChange, ...restProps } = props
  const {
    state,
    statusList,
    handleBeforeUpload,
    handleReUpload,
    handlePreview,
    cancelPreviewModal,
  } = useSetupHook(props)
  const { uploadFileList, previewModalOption } = state
  const columns = [
    {
      key: 'name',
      dataIndex: 'name',
      title: '文件名',
      render: (text: any, record: UploadFileItem) => {
        return (
          <Space>
            <span
              className="cursor-pointer"
              onClick={() => handlePreview(record)}
            >
              {text}
            </span>
            {record.resultType === '失败' && record.errorMessage !== '' ? (
              <Space>
                <InfoCircleFilled
                  style={{
                    color: 'red',
                  }}
                />
                <span>{record.errorMessage}</span>
              </Space>
            ) : null}
          </Space>
        )
      },
    },
    {
      key: 'resultType',
      dataIndex: 'resultType',
      title: '结果',
      filters: [
        { text: '成功', value: '成功' },
        { text: '失败', value: '失败' },
      ],
      onFilter: (value: any, record: UploadFileItem) =>
        record.resultType.includes(value),
      render: (text: any, record: UploadFileItem) => {
        switch (record.resultType) {
          case '上传中':
            return <span>上传中...</span>
          case '成功':
            return <span>成功</span>
          case '失败':
            return (
              <Space>
                <span className="btn-danger">失败</span>
                <Upload
                  accept={'image/*'}
                  beforeUpload={(file, fileList) => {
                    handleReUpload(file, fileList, record.uid)
                    return false
                  }}
                  showUploadList={false}
                >
                  <span className="btn-link">重新上传</span>
                </Upload>
              </Space>
            )
        }
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Space>
        <Upload
          accept={'image/*'}
          {...restProps}
          className={styles['upload-style']}
          multiple
          customRequest={() => {
            return
          }}
          beforeUpload={_.debounce(handleBeforeUpload, 300) as any}
          // beforeUpload={handleBeforeUpload}
          // antd的upload事件在批量上传时会多次触发
          // onChange={_.debounce(handleUploadChange, 300)}
          showUploadList={false}
        >
          {uploadButton ?? <Button size="middle">选择图片</Button>}
        </Upload>
        <span>
          支持bmp 、gif 、jpg 、png 、webp
          、heic，图片大小不高于2M。最多512张图片，超出部分将上传失败
        </span>
      </Space>
      {uploadFileList.length > 0 ? (
        <div className={styles['list-container']}>
          <div className={styles['status-line']}>
            <div className={styles['status']}>
              {statusList.progress < statusList.total ? (
                <Space>
                  <SyncOutlined className="rotate-loading" />
                  <span>上传中，请耐心等待......</span>
                </Space>
              ) : (
                <Space>
                  <CheckOutlined /> <span> 上传完成！</span>
                </Space>
              )}
            </div>
            <div className={styles['progress']}>
              <Space>
                <span>
                  上传进度：{statusList.progress}/{statusList.total}
                </span>
                <span>成功：{statusList.succeedCount}个</span>
                <span>失败：{statusList.failCount}个</span>
              </Space>
            </div>
          </div>
          <div className={styles['table-container']}>
            <Table
              columns={columns}
              dataSource={uploadFileList}
              getPopupContainer={() => document.body}
              rowKey="uid"
              pagination={false}
              scroll={{ y: 350 }}
            ></Table>
          </div>
        </div>
      ) : null}
      <PreviewModal
        {...previewModalOption}
        onCancel={cancelPreviewModal}
      ></PreviewModal>
    </div>
  )
}
import { ReactNode } from 'react'
import styles from './styles.module.scss'
import { Button, Space, Table, Upload } from 'antd'
import { RcFile, UploadProps } from 'antd/lib/upload'
import { useSetupHook } from './hooks'
import {
  CheckOutlined,
  SyncOutlined,
  InfoCircleFilled,
} from '@ant-design/icons'
import _ from 'lodash'
import PreviewModal from '../previewModal'
export type ResultType = '上传中' | '成功' | '失败'
// export type ErrorType='exceedLimit'|'timeout'|'不支持此文件格式'
export const resultDict: { [key in ResultType]: any } = {
  上传中: {
    node: <span>上传中...</span>,
  },
  成功: { node: <span> 成功</span> },
  失败: { node: <span> 失败</span> },
}
export interface UploadFileItem
  extends Partial<Pick<RcFile, 'size' | 'name' | 'uid' | 'type'>> {
  uid: string
  name: string
  resultType: ResultType
  errorMessage?: string
  originFile: File
  osspath?: string
  url: string
}
export interface Props extends Omit<UploadProps, 'onChange'> {
  uploadButton?: ReactNode
  maxCount?: number
  onChange?: (newUploadFileList: UploadFileItem[]) => void
  value?: any
}
export default function BatchUpload(props: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { uploadButton, onChange, ...restProps } = props
  const {
    state,
    statusList,
    handleBeforeUpload,
    handleReUpload,
    handlePreview,
    cancelPreviewModal,
  } = useSetupHook(props)
  const { uploadFileList, previewModalOption } = state
  const columns = [
    {
      key: 'name',
      dataIndex: 'name',
      title: '文件名',
      render: (text: any, record: UploadFileItem) => {
        return (
          <Space>
            <span
              className="cursor-pointer"
              onClick={() => handlePreview(record)}
            >
              {text}
            </span>
            {record.resultType === '失败' && record.errorMessage !== '' ? (
              <Space>
                <InfoCircleFilled
                  style={{
                    color: 'red',
                  }}
                />
                <span>{record.errorMessage}</span>
              </Space>
            ) : null}
          </Space>
        )
      },
    },
    {
      key: 'resultType',
      dataIndex: 'resultType',
      title: '结果',
      filters: [
        { text: '成功', value: '成功' },
        { text: '失败', value: '失败' },
      ],
      onFilter: (value: any, record: UploadFileItem) =>
        record.resultType.includes(value),
      render: (text: any, record: UploadFileItem) => {
        switch (record.resultType) {
          case '上传中':
            return <span>上传中...</span>
          case '成功':
            return <span>成功</span>
          case '失败':
            return (
              <Space>
                <span className="btn-danger">失败</span>
                <Upload
                  accept={'image/*'}
                  beforeUpload={(file, fileList) => {
                    handleReUpload(file, fileList, record.uid)
                    return false
                  }}
                  showUploadList={false}
                >
                  <span className="btn-link">重新上传</span>
                </Upload>
              </Space>
            )
        }
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Space>
        <Upload
          accept={'image/*'}
          {...restProps}
          className={styles['upload-style']}
          multiple
          customRequest={() => {
            return
          }}
          beforeUpload={_.debounce(handleBeforeUpload, 300) as any}
          // beforeUpload={handleBeforeUpload}
          // antd的upload事件在批量上传时会多次触发
          // onChange={_.debounce(handleUploadChange, 300)}
          showUploadList={false}
        >
          {uploadButton ?? <Button size="middle">选择图片</Button>}
        </Upload>
        <span>
          支持bmp 、gif 、jpg 、png 、webp
          、heic，图片大小不高于2M。最多512张图片，超出部分将上传失败
        </span>
      </Space>
      {uploadFileList.length > 0 ? (
        <div className={styles['list-container']}>
          <div className={styles['status-line']}>
            <div className={styles['status']}>
              {statusList.progress < statusList.total ? (
                <Space>
                  <SyncOutlined className="rotate-loading" />
                  <span>上传中，请耐心等待......</span>
                </Space>
              ) : (
                <Space>
                  <CheckOutlined /> <span> 上传完成！</span>
                </Space>
              )}
            </div>
            <div className={styles['progress']}>
              <Space>
                <span>
                  上传进度：{statusList.progress}/{statusList.total}
                </span>
                <span>成功：{statusList.succeedCount}个</span>
                <span>失败：{statusList.failCount}个</span>
              </Space>
            </div>
          </div>
          <div className={styles['table-container']}>
            <Table
              columns={columns}
              dataSource={uploadFileList}
              getPopupContainer={() => document.body}
              rowKey="uid"
              pagination={false}
              scroll={{ y: 350 }}
            ></Table>
          </div>
        </div>
      ) : null}
      <PreviewModal
        {...previewModalOption}
        onCancel={cancelPreviewModal}
      ></PreviewModal>
    </div>
  )
}
